import { Injectable, Inject, Optional } from '@angular/core';
import {
    NgxMatMomentAdapter,
    NgxMatMomentDateAdapterOptions,
    NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular-material-components/moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import 'moment/locale/pt-br';

@Injectable()
export class CustomDateAdapter extends NgxMatMomentAdapter {
    constructor(
        @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
        @Optional() @Inject(NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS) options?: NgxMatMomentDateAdapterOptions
    ) {
        super(dateLocale, options);
        super.setLocale('pt-BR');
        moment.locale('pt-BR');
    }

    getDayOfWeekNames(style: 'long' | 'short' | 'narrow') {
        let response = super.getDayOfWeekNames(style);

        if (style == 'narrow') {
            response = super.getDayOfWeekNames('short');
        }

        return response;
    }
}
